import VuexTypes from '@/store/types/index';

const InvoicesTypes = VuexTypes.invoices;
export default {
  [InvoicesTypes.INVOICES_LIST]: (state, { data, status }) => {
    state.invoicesList = { data, status };
  },
  [InvoicesTypes.INVOICES_LIST_FILTERS]: (state, { data, status }) => {
    state.invoicesListFilters = { data, status };
  },
  [InvoicesTypes.INVOICE_CLASSIFIERS]: (state, { data, status }) => {
    state.invoiceClassifiers = { data, status };
  },
  [InvoicesTypes.INVOICE_CREATE_DATA]: (state, { data, status }) => {
    state.invoiceCreateData = { data, status };
  },
  [InvoicesTypes.INVOICE_UPDATE_DATA]: (state, { data, status }) => {
    state.invoiceUpdateData = { data, status };
  },
  [InvoicesTypes.INVOICE_MEDIA_LIST]: (state, { data, status }) => {
    state.invoiceMediaList = { data, status };
  },
  [InvoicesTypes.INVOICE_CREATE]: (state, { data, status }) => {
    state.invoiceCreate = { data, status };
  },
  [InvoicesTypes.INVOICE_UPDATE]: (state, { data, status }) => {
    state.invoiceUpdate = { data, status };
  },
  [InvoicesTypes.INVOICE_ITEMS_LIST]: (state, { data, status }) => {
    state.invoiceItemsList = { data, status };
  },
  [InvoicesTypes.INVOICE_ITEMS_UPDATE]: (state, { data, status }) => {
    state.invoiceItemsUpdate = { data, status };
  },
  [InvoicesTypes.INVOICE_UPDATE_DETAINED_PAYMENT]: (state, { data, status }) => {
    state.invoiceUpdateDetainedPayment = { data, status };
  },
  [InvoicesTypes.INVOICE_PAYMENT_APPROVE]: (state, { data, status }) => {
    state.invoicePaymentApprove = { data, status };
  },
  [InvoicesTypes.INVOICE_PAYMENT_REJECT]: (state, { data, status }) => {
    state.invoicePaymentReject = { data, status };
  },
  [InvoicesTypes.INVOICE_ACTIVITY]: (state, { data, status }) => {
    state.invoiceActivity = { data, status };
  },
  [InvoicesTypes.INVOICE_DELETE]: (state, { data, status }) => {
    state.invoiceDelete = { data, status };
  },
  [InvoicesTypes.INVOICE_DELETE_ATTACHMENT]: (state, { data, status }) => {
    state.invoiceDeleteAttachment = { data, status };
  },
  [InvoicesTypes.UPDATE_NEW_INVOICE_FTP_FILES]: (state, data) => {
    state.newInvoiceFtpFiles = data;
  },
  [InvoicesTypes.UPDATE_NEW_INVOICE_FILES]: (state, data) => {
    state.newInvoiceFiles = data;
  }
};
